import L from 'leaflet';

const DEFAULTS = {
};

/**
 * @extends {L.Evented}
 */
class ControlManagement extends L.Evented {
	/**
	 * @param {Widget} widget
	 * @param {object} options
	 */
	constructor(widget, options) {
		super();

		this.widget = widget;
		this.options = Object.assign({}, DEFAULTS, options);
		this.addEventParent(widget);

		this._controls = {};
	}

	/**
	 * @param {L.Control} control
	 */
	addControl(control) {
		if (this._controls[control.options.name] === undefined) {
			this._controls[control.options.name] = control;
			this.widget.map._map.addControl(control);
		}
	}

	/**
	 * @param {string} name
	 */
	removeControl(name) {
		let control = this._controls[name];

		if (control) {
			this.widget.map._map.removeControl(control);
			delete this._controls[name];
		}
	}

	/**
	 *
	 */
	destroy() {
		this.removeEventParent(this.widget);
	}
}

export function controlManagement(widget, options) {
	return new ControlManagement(widget, options);
}

export default ControlManagement;
